module.exports = __webpack_public_path__ + "media/app/assets/imgs/events/note-370b82bd5af667425b5e0a1a63684243.svg";